// extracted by mini-css-extract-plugin
module.exports = {"survey":"LiveSurvey_survey__3VLq7"};